/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmployeeSupplyUsage {
    angular.module("meevo.plugins.employeeSupplyUsage", []);
}